import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput from "../Select/BaseSelectorReadonlyToInput";
import AssetService from "../../services/AssetService";

class AssetTagsSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      defaultValue: props.defaultValue && props.defaultValue.map(x => ({'tags.value': x.tags.value, ...x})),
      title: props.title || 'Produto/Ativo',
      label: 'tags.value',
      url: AssetService.ALL_TAGS_URL,
      placeholder: props.placeholder,
      style: props.style,
    };
  }
}

AssetTagsSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
  multiple: PropTypes.bool,
  placeholder: PropTypes.string
};

export default AssetTagsSelector;



// WEBPACK FOOTER //
// ./src/component/Asset/AssetTagsSelector.js